import { create } from 'zustand';
import useLoadingStore from './use-loading';
import { makeRequest } from 'api/api-client';
import { HTTP } from 'constants/http-method';
import { API_ENDPOINTS } from 'api/endpoints';

const useStaffMemberProfileDetailsStore = create((set) => ({
  profile: {
    personalDetails: null,
    educationHistory: null,
    employmentHistory: null,
  },

  // Function to get profile details
  getProfileDetails: async ({ id, successCallback }) => {
    useLoadingStore.getState().setLoading(true);
    try {
      const { data: response } = await makeRequest(
        HTTP.GET,
        API_ENDPOINTS.GET_CAREGIVER_DETAILS,
        null,
        null,
        id
      );
      if (response.success) {
        const {
          userProfile,
          educationHistory,
          employmentHistory,
          emergencyContacts,
        } = response.data?.data || {};
        set({
          profile: {
            educationHistory,
            employmentHistory,
            personalDetails: { ...userProfile, emergencyContacts },
          },
        });
        successCallback && successCallback(response.data.data.userProfile);
      }
    } catch (error) {
    } finally {
      useLoadingStore.getState().setLoading(false);
    }
  },

  // Function to update personal details
  updatePersonalDetails: async ({ id, data, successCallback }) => {
    useLoadingStore.getState().setLoading(true);
    try {
      const { data: response } = await makeRequest(
        HTTP.PUT,
        API_ENDPOINTS.UPDATE_CAREGIVER_PERSONAL_DETAILS,
        data,
        null,
        id
      );

      if (response.success) {
        const updatedPersonalDetails = response.data?.data;
        set((state) => ({
          profile: {
            ...state.profile,
            personalDetails: { ...updatedPersonalDetails },
          },
        }));
        successCallback && successCallback(response);
      }
    } catch (error) {
    } finally {
      useLoadingStore.getState().setLoading(false);
    }
  },

  // Function to update education history
  updateEducationHistory: async ({ id, data, successCallback }) => {
    useLoadingStore.getState().setLoading(true);
    try {
      const { data: response } = await makeRequest(
        HTTP.PUT,
        API_ENDPOINTS.UPDATE_CAREGIVER_EDUCATION_HISTORY,
        data,
        null,
        id
      );

      if (response.success) {
        const updatedEducationHistory = response.data;
        set((state) => ({
          profile: {
            ...state.profile,
            educationHistory: updatedEducationHistory,
          },
        }));
        successCallback && successCallback(response);
      }
    } catch (error) {
    } finally {
      useLoadingStore.getState().setLoading(false);
    }
  },

  // Function to update employment history
  updateEmploymentHistory: async ({ id, data, successCallback }) => {
    useLoadingStore.getState().setLoading(true);
    try {
      const { data: response } = await makeRequest(
        HTTP.PUT,
        API_ENDPOINTS.UPDATE_CAREGIVER_EMPLOYMENT_HISTORY,
        data,
        null,
        id
      );

      if (response.success) {
        const updatedEmploymentHistory = response.data;
        set((state) => ({
          profile: {
            ...state.profile,
            employmentHistory: updatedEmploymentHistory,
          },
        }));
        successCallback && successCallback(response);
      }
    } catch (error) {
    } finally {
      useLoadingStore.getState().setLoading(false);
    }
  },

  // Functions of Add employe history
}));

export default useStaffMemberProfileDetailsStore;
